import React from "react";
import { Box, Radio, Typography } from "@mui/material";

interface PlateformChipProps {
  label: string;
  icon: string; // URL of the icon image
  selected: boolean;
  onClick: () => void;
}

const PlateformChip: React.FC<PlateformChipProps> = ({
  label,
  icon,
  selected,
  onClick,
}) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        display: "flex",
        flexShrink: 0,
        alignItems: "center",
        gap: 1,
        padding: "8px 12px",
        boxShadow:"0 0 5px rgb(194, 194, 194)",
        borderRadius: "7px",
        cursor: "pointer",
        transition: "0.3s",
        "&:hover": {
          borderColor: "#888",
        },
      }}
    >
      {/* Radio Button */}
      <Radio
        checked={selected}
        onChange={onClick}
        sx={{
          padding: 0,
          "& .MuiSvgIcon-root": {
            fontSize: 18,
          },
          color: "#888",
          "&.Mui-checked": {
            color: "#007bff",
          },
        }}
      />

      <img src={icon} alt={label} className="" />

      <Typography
        variant="body1"
        noWrap
        sx={{
          textOverflow: "normal",
          width: "100%",
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default PlateformChip;
